import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UpdateAccountStatusResultModal} from './update-account-status.result.modal';
import {
    clearResult,
    selectUpdateAccountStatusBulkUuid,
    selectUpdateAccountStatusShown,
    selectUpdateAccountStatusTask,
} from './update-account-status.slice';

export const UpdateAccountStatusResult = () => (
    <BulkActionResult
        actionIdSelector={selectUpdateAccountStatusBulkUuid}
        actionTaskSelector={selectUpdateAccountStatusTask}
        actionShownSelector={selectUpdateAccountStatusShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <UpdateAccountStatusResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
